var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.37695 5.08862H9.04321V6.62796H5.37695V5.08862Z",
    fill: "#002A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37695 8.58887H9.04321V10.1282H5.37695V8.58887Z",
    fill: "#002A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37695 12.0892H9.04321V13.6286H5.37695V12.0892Z",
    fill: "#002A3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37695 15.5895H9.04321V17.1288H5.37695V15.5895Z",
    fill: "#002A3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7928 19.1786V6.60082L20.8308 6.59143V20.2328H22.3692V5.82087C22.3692 5.40097 22.0184 5.05118 21.5991 5.05118L12.0227 5.06236C11.5982 5.06287 11.2544 5.40728 11.2544 5.83205V19.1786H3.16923V3.94805L11.2544 1.77302V6.80171H12.7928V0.769074C12.7928 0.271125 12.3051 -0.103644 11.8238 0.0257917L2.20026 2.61466C1.86431 2.70507 1.63077 3.00984 1.63077 3.35795V19.1786H0V20.7179H24V19.1786H12.7928Z",
    fill: "#002A3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8301 16.462H22.3685V17.8959H20.8301V16.462Z",
    fill: "#002A3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9531 8.58911H18.6194V10.1284H14.9531V8.58911Z",
    fill: "#002A3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9531 12.0892H18.6194V13.6286H14.9531V12.0892Z",
    fill: "#002A3A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9531 15.5897H18.6194V17.1291H14.9531V15.5897Z",
    fill: "#002A3A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/City.7e55372e016a04f2bb4e49fe12d9ccd3.svg";
export { ForwardRef as ReactComponent };